import { WorkflowConfig } from '../lib/types'

const reviewTypes = ['review', 'approve']

export default function advanceStep(
    config: WorkflowConfig,
    id: number | string,
    stepIndex: number | string,
    rowId: number | string,
) {
    let nextIndex = Number(stepIndex) + 1
    let nextStep = config?.steps[nextIndex]
    if (!nextStep) return `/workflows/${id}`
    let viewType = reviewTypes.includes(nextStep.type) ? 'review' : 'view'
    return `/workflows/${id}/steps/${nextIndex}/${viewType}/${rowId}`
}
